import { render, staticRenderFns } from "./InvalidUdiDialog.vue?vue&type=template&id=b2cf136c&scoped=true&"
import script from "./InvalidUdiDialog.vue?vue&type=script&lang=js&"
export * from "./InvalidUdiDialog.vue?vue&type=script&lang=js&"
import style0 from "./InvalidUdiDialog.vue?vue&type=style&index=0&id=b2cf136c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cf136c",
  null
  
)

export default component.exports